import styled from 'styled-components';
import {
    PlayerMatchupWrapper,
    PlayerNameWrapper,
    PlayerDataWrapper,
    PlayerInfoWrapper,
    PlayerDecisionWrapper,
    PlayerStatsWrapper
} from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';

import Button from '@mlb/react-patterns/v4/components/Button/button';
import { TeamSummaryMatchUpWrapper } from '../TeamSummaryMatchup/TeamSummaryMatchup.style';

import { BaseVoteLink } from '../PlayerOfTheGame/PlayerOfTheGame.style';

import Link from '@mlb/react-patterns/v4/components/Link/link';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

export const ViewWrapButton = styled(Button)`
    height: 48px;
    border-radius: 48px;
    font-size: 16px;
    width: 100%;
    margin-top: var(--gameday-section-padding-sm);
    background-color: var(--gameday-button-solid-background);
`;

export const TiebreakerButton = styled(Button)`
    font-size: 16px;
    width: 100%;
    margin-top: var(--gameday-section-padding-sm);
    background-color: var(--gameday-background-color) !important;
    color: var(--gameday-action-button-color) !important;
`;

export const GameOverTitleWrapper = styled.div`
    padding-bottom: var(--gameday-section-padding-sm);
    color: var(--gameday-primary-font-color);
    font-size: 20px;
    line-height: 20px;
    text-align: center;
    border-bottom: 1px solid var(--gameday-gameover-divider-color);
`;

export const GameOverMatchupWrapper = styled.div`
    >div {
        border-bottom: 1px solid var(--gameday-gameover-divider-color);
    }
`;

export const GameOverLineScoreWrapper = styled.div`
    padding: var(--gameday-section-padding-sm) 0px;
    border-bottom: 1px solid var(--gameday-gameover-divider-color);
    >div {
        height: 78px;
        border-bottom: none;
    }
`;

export const GameOverDecisionsWrapper = styled.div`
    padding: var(--gameday-section-padding-sm);
    border-bottom: 1px solid var(--gameday-gameover-divider-color);

    >div {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        >a {
            display: block;
            width: 50%;
            &:nth-child(2) {
                ${PlayerMatchupWrapper} {
                    margin-left: auto;
                    margin-right: 0px;
                }
            }
            &:nth-child(3) {
                ${PlayerMatchupWrapper} {
                    margin-top: 20px;
                }
            }
        }
    }

    ${PlayerMatchupWrapper} {
        display: block;
        text-align: center;
        width: 120px;


        ${PlayerDataWrapper} {
            margin-left: 0px;
            text-align: center;
        }
        ${PlayerNameWrapper} {
            border-bottom: none !important;
            line-height: 14px;
            font-size: 14px;
            color: var(--gameday-primary-font-color);
        }
        ${PlayerDecisionWrapper} {
            line-height: 14px;
            font-size: 14px;
            color: var(--gameday-decisions-stats-color);
        }
        ${PlayerInfoWrapper} {
            width: 100%;
            display: block;
            line-height: 14px;
            font-size: 14px;
        }
        ${PlayerStatsWrapper} {
            margin-top: 5px;
            line-height: 12px;
            font-size: 12px;
            font-weight: bold;
            color: var(--gameday-decisions-stats-color);
            >span {
                color: var(--gameday-decisions-pipe-color);
            }
        }
    }
`;

export const GameOverLinkWrapper = styled.div``;

export const GameOverWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    max-width: 375px;
    background-color: var(--gameday-background-color);
    padding: 24px;

    ${TeamSummaryMatchUpWrapper} {
        padding: var(--gameday-section-padding-sm) 0px;
    }

    ${BaseVoteLink} {
        margin-top: var(--gameday-section-padding-sm);
    }
`;

export const TiebreakerLink = styled(Link)`
    color: ${COLORS.linkBlue} !important;
`;
